
























































import Loader from '@/contexts/frontend/Loader.vue'

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String,
    projectId: String
  },
  data: function() {
    return {
      project: {
        id: '',
        name: '',
        slug: ''
      },
      loading: false
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .GetProject(this.projectId)
      .then(result => (this.project = result[0]))
      .finally(() => (this.loading = false))
  },
  methods: {
    saveProject() {
      this.$api.clientAdmin
        .UpdateProject(this.project)
        .then(() => this.$router.push({ name: 'settings-projects-list' }))
    }
  }
}
